import { RatingStars } from '@/components/ratingStars';
import { FilterLabel } from '@/features/products/types/filterLabel';

export const RatingFilterLabel = ({ filter, children }: FilterLabel) => {
  const rating = Number(filter.code);
  return (
    <div className="flex items-center gap-2">
      <span className="w-10.5 text-sm">{filter.name}</span>
      <RatingStars rating={rating} />
      <span className="text-sm text-(--mui-palette-text-disabled)">
        {!!filter.count && `(${filter.count})`}
      </span>
      {children}
    </div>
  );
};
